import React from "react"

export class Download extends React.PureComponent {
  componentDidMount() {
    const downloadPath = location.pathname.replace(/^\/download/, '');
    const directory = downloadPath.match(/(^\/.*?)\//)[1]
    const file = downloadPath.replace(new RegExp(`^${directory}\\/`), '/');
    const redirect = () => {
      if (!this.downloaded) {
        location.replace(downloadPath)
        this.downloaded = true;
      }
    };

    setTimeout(redirect, 1000);

    window.gtag('event', 'download', {
      'event_category': directory,
      'event_label': file,
      'event_callback': redirect,
    });
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Download/index.js